import { render, staticRenderFns } from "./DriverBlackListAdd.vue?vue&type=template&id=3b45c3ac&scoped=true"
import script from "./DriverBlackListAdd.vue?vue&type=script&lang=js"
export * from "./DriverBlackListAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45c3ac",
  null
  
)

export default component.exports